<template>
    <div>
        <h6 class="mb-4 text-uppercase" v-if="hasTitle">
            <strong>Dados do Produto</strong>
        </h6>
        <a-form layout='vertical'>
            <a-form-item v-bind="{ label: 'Nome produto', ...nameProps }">
                <a-input size="large" placeholder="Informe nome do produto" v-model="form.name"/>
                </a-form-item>

            <a-form-item v-bind="{ label: 'ID Fiscal', ...fiscalProps }">
                <a-input
                size="large"
                v-model="form.fiscal_id"
                placeholder="Coloque o ID pra nota fiscal"
                />
            </a-form-item>

            <a-form-item  v-bind="{ label: 'Preço Unit.', ...priceProps }">
                <money style="width: 120px" class="ant-input ant-input-lg" v-model="form.price" v-bind="vmoneyConfig"></money>
            </a-form-item>
            <a-form-item label="Produto físico">
                <a-switch v-model="form.physical" />
            </a-form-item>
            <a-form-item>
              <button @click="submitProductForm" class='kiwi-button'>
                {{buttonText}}
              </button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
export default {
  props: {
    data: {
      type: Object,
    },
    hasTitle: {
      type: Boolean,
      default: true,
    },
    buttonText: {
      type: String,
      default: 'Salvar Produto',
    },
  },
  data() {
    return {
      form: {
        name: '',
        fiscal_id: '',
        price: 0,
        physical: true,
      },
    }
  },
  computed: {
    ...mapGetters(['vmoneyConfig', 'loadingActive', 'token']),
    nameProps() {
      if (!this.$v.form.name.required && this.$v.form.name.$error) {
        return {
          'validate-status': 'error',
          'help': 'Informe um nome',
        }
      }
      return {}
    },
    fiscalProps() {
      if (!this.$v.form.fiscal_id.required && this.$v.form.fiscal_id.$error) {
        return {
          'validate-status': 'error',
          'help': 'Informe um ID fiscal',
        }
      }
      return {}
    },
    priceProps() {
      if (!this.$v.form.price.required && this.$v.form.price.$error) {
        return {
          'validate-status': 'error',
          'help': 'Informe um preço pro produto',
        }
      }
      return {}
    },
  },
  methods: {
    submitProductForm() {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.form.price = this.form.price * 100
        this.$emit('saved', this.form)
      }
    },
  },
  validations: {
    form: {
      name: {
        required,
      },
      fiscal_id: {
        required,
      },
      price: {
        required,
      },
    },
  },
  mounted() {
    if (this.data) {
      this.form = this.data
      this.form.price = this.data.price / 100
    }
  },
}
</script>
